import http from '../../../../libs/http'
export default (id, payload) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/requests/${id}`, payload)
